import canusewebp from './canusewebp'

const getImageUrl = (image) => {
	if (image) {
		return image[canusewebp() && image.webpurl ? 'webpurl' : 'url']
	}
	return '/images/placeholder.png'
}

export default getImageUrl



// WEBPACK FOOTER //
// ./src/utilities/getImageUrl.js